/* eslint-disable class-methods-use-this */
import { Benefit } from "src/shared/models/benefit.model";
import { PgaPolicy } from "src/shared/models/pga-policy.model";
import { DayjsUtils } from "src/libs/dayjs-utils";
import { ProductCategories } from "src/constants/product-categories";

export class MultiventajasBenefit extends Benefit {
    static _allowedCategories: string[] = [
        ProductCategories.VIDA,
        ProductCategories.RENTAS,
        ProductCategories.ACCIDENTES,
        ProductCategories.AUTOS,
        ProductCategories.SOAT,
        ProductCategories.HOGAR,
        ProductCategories.HIPOTECARIO,
    ];

    private static _isFlagEnabled(): boolean {
        return (
            process.env.REACT_APP_WELLNESS_DISCOUNTS_MULTIVENTAJAS_ENABLED ===
            "on"
        );
    }

    private static _isPolicyAllowed(policy: PgaPolicy): boolean {
        const { category } = policy.product;
        return MultiventajasBenefit._allowedCategories.includes(category);
    }

    private static _isPolicyInForce(policy: PgaPolicy): boolean {
        const categoriesWithNoValidityEnd = [ProductCategories.RENTAS];

        const meetStart = DayjsUtils.getDate(new Date(policy.validityStart));
        const meetEnd = DayjsUtils.getDate(new Date(policy.validityEnd));
        const now = DayjsUtils.getDate(new Date());

        const isRentalPolicy = categoriesWithNoValidityEnd.includes(
            policy.product?.category as ProductCategories
        );

        // Policy is not future and is in effect
        // `meetEnd` is not used for Rental products
        //  because they do not have a valid `validityEnd` value
        if (isRentalPolicy) {
            return DayjsUtils.isSameOrBefore(meetStart, now);
        }

        return (
            DayjsUtils.isSameOrBefore(meetStart, now) &&
            DayjsUtils.isSameOrAfter(meetEnd, now)
        );
    }

    static hasAccess(policies: PgaPolicy[]): boolean {
        const clazz = MultiventajasBenefit;
        const isFlagEnabled = clazz._isFlagEnabled();
        const isQualified = policies.some((policy) => {
            const isAllowed = clazz._isPolicyAllowed(policy);
            const isPolicyInForce = clazz._isPolicyInForce(policy);
            return isAllowed && isPolicyInForce;
        });
        return isQualified && isFlagEnabled;
    }
}
